<template>
  <div>
    <b-card>
      <div slot="header">
        <span v-html="cardTitle" />
      </div>
      <LoadingSpinner :loading="isOverlay" :text="$lang.sending_data" />
      <b-form v-if="!isOverlay">
        <b-form-group
          :label="$lang.sample_evidence"
          label-for="evidence"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.sample_evidence"
            :rules="$v.sample.$params"
          />
          <b-form-textarea
            :readonly="includes(userExecutiveRoleId, [4, 5, 6, 7])"
            id="sample"
            type="text"
            v-model="$v.sample.$model"
            :state="$v.sample.$dirty ? !$v.sample.$error : null"
            :autocomplete="$lang.sample"
            :rows="5"
          ></b-form-textarea>
          <b-form-invalid-feedback id="father_name-feedback">{{
            $lang.error_required | replace($lang.sample_evidence)
          }}</b-form-invalid-feedback>
        </b-form-group>
        <!-- ارزیاب زمانی عنوان خطا را میبیند که خطا ثبت شده باشد اما بقیه افراد در هر حالت خطا را میبینند -->
        <b-form-group
          v-if="
            (includes(userExecutiveRoleId, [2]) && error_selected) ||
            !includes(userExecutiveRoleId, [2])
          "
          :label="$lang.error_selected"
          label-for="evidence"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.error_code"
            :rules="$v.error_selected.$params"
          />
          <!-- مدیر کانون و ارزیاب امکان تغییر عنوان خطا را ندارند -->
          <selectFind
            :options="error_options"
            v-model="$v.error_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.error_selected.$dirty ? !$v.error_selected.$error : null
            "
            :showButton="false"
            :disabled="includes(userExecutiveRoleId, [2])"
          />
          <b-form-invalid-feedback id="father_name-feedback">{{
            $lang.error_required | replace($lang.error_selected)
          }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          v-if="
            (includes(userExecutiveRoleId, [2]) && error_selected) ||
            !includes(userExecutiveRoleId, [2])
          "
          :label="$lang.error_description"
          label-for="evidence"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.error_description"
            :rules="$v.error_description.$params"
          />
          <b-form-textarea
            id="error_description"
            type="text"
            v-model="$v.error_description.$model"
            :disabled="!$v.error_selected.$model"
            :state="
              $v.error_description.$dirty ? !$v.error_description.$error : null
            "
            :autocomplete="$lang.error_description"
            :rows="3"
          />
          <b-form-invalid-feedback id="father_name-feedback">{{
            $lang.error_required | replace($lang.error_description)
          }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group :label="$lang.status" :label-cols="12" class="d-none">
          <requiredComponent
            slot="label"
            :label="$lang.status"
            :rules="$v.status.$params"
          />

          <b-form-radio-group
            :autocomplete="$lang.status"
            v-model="$v.status.$model"
            :options="status_options"
            :state="$v.status.$dirty ? !$v.status.$error : null"
            buttons
            button-variant="outline-primary"
            size="sm"
            name="radio-btn-outline"
          ></b-form-radio-group>
        </b-form-group>
        <div class="float-right">
          <b-button
            class="mr-1"
            variant="outline-danger"
            @click="cancelEvidence"
          >
            <mdicon name="close" size="20" />
            {{ $lang.cancelButton }}
          </b-button>
          <b-button
            class="ml-1"
            variant="success"
            @click="submit()"
            :disabled="!isEditable"
          >
            <mdicon name="check" size="20" />
            {{ $lang.submitButton }}
          </b-button>

          <b-button
            v-if="
              !includes(userExecutiveRoleId, [2]) &&
              pathOr(null, ['error'], item)
            "
            class="ml-1"
            variant="warning"
            @click="resetEvidenceLog()"
            :disabled="!isEditable"
            v-b-tooltip.hover
            :title="$lang.resetErrorAndSubmitTooltip"
          >
            <mdicon name="check" size="20" />
            {{ $lang.resetErrorAndSubmit }}
          </b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { generateApiUrl, renderEumOptions } from "@/shared/utils";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr, includes } from "ramda";

export default {
  name: "evidence-score-form",
  components: {
    LoadingSpinner,
  },
  validations: {
    evidence: { required },
    status: {},
    sample: {},
    error_selected: {},
    error_description: {
      requiredIf: requiredIf((vm) => vm.error_selected),
    },
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    mode: {
      type: String,
      default: "add",
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    userExecutiveRoleId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      evidence: null,
      status: null,
      sample: null,
      error_selected: null,
      error_description: null,
      isOverlay: false,
      caption_imperative: null,
      caption_third_person: null,
    };
  },
  computed: {
    error_options() {
      return renderEumOptions("error_code");
    },
    status_options() {
      return renderEumOptions("");
    },
    cardTitle() {
      return `<b>${this.$lang.evidence_second_person}: ${this.evidence}</b>`;
    },
  },
  watch: {
    item() {
      if (this.item) {
        this.evidence = pathOr(null, ["evidence"], this.item);
        this.status = this.status_options.find(
          (x) => x.value === pathOr(null, ["status", "id"], this.item)
        );
      }
    },
    sample(value) {
      this.$emit("setSampleField", value);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    renderEumOptions,
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      const payload = {
        error_description: this.error_description,
        error_code: pathOr(null, ["value"], this.error_selected),
        sample: this.sample,
        status: pathOr(false, ["checked"], this.item) ? 1 : 0,
      };
      this.$emit("submit", payload);
      this.isOverlay = true;
    },
    async resetEvidenceLog() {
      try {
        this.isOverlay = true;
        const id = pathOr(null, ["evidence_data_id"], this.item);
        const url = generateApiUrl(["kanoon", "evidence_history_log"], [id]);
        const payload = { is_enable: 0 };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.error_selected = null;
        this.error_description = null;
        this.$emit("refresh");
        this.$emit("cancel");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isOverlay = false;
      }
    },
    cancelEvidence() {
      this.$emit("cancel", false);
      this.$emit("modal-close", false);
    },
    fetchData() {
      if (this.mode === "edit") {
        this.evidence = pathOr(null, ["evidence"], this.item);
        this.caption_third_person = pathOr(
          null,
          ["caption_third_person"],
          this.item
        );
        this.caption_imperative = pathOr(
          null,
          ["caption_imperative"],
          this.item
        );
        this.error_description = pathOr(null, ["error_description"], this.item);
        this.sample = pathOr(null, ["sample"], this.item) || "";
        this.error_selected = this.error_options.find(
          (x) => x.value === pathOr(null, ["error", "id"], this.item)
        );
      }
    },
  },
};
</script>
